/**
 * 成员详情 · 区块常量（S1：单页 + 锚点）
 * ------------------------------------------------------------------
 * 区块列表与 DOM id 的**唯一来源**：容器（coachProfile）渲染 section，
 * 页面级锚点栏（MemberTab 的第三栏）渲染导航，两边都从这里取，
 * 避免两处手写导致「点了锚点跳不到」。
 *
 * 会话记录是无界列表（聊天流）→ 按 §12.1 的约束排最后，
 * 否则它会把下面所有区块推得很远。
 */
export const COACH_SECTIONS = [
  { key: 'overview', label: '概览信息' },
  { key: 'base', label: '基础信息' },
  { key: 'settle', label: '结算银行' },
  { key: 'biz', label: '业务信息' },
  { key: 'alipay', label: '支付宝签约' },
  { key: 'session', label: '会话记录' },
];

export const sidOf = (key) => `coach-${key}`;
